import React, { useEffect, useState } from "react";
import { Field, Form, Button } from "@bwevents/components";
import { Link, useNavigate } from "react-router-dom";
import SocialLogin from "../components/SocialLogin";
import InputPassword from "../components/InputPassword";
import { Validations } from "../services/Validations";
import { Loading } from "common/pages";

import "./Login.scss";

export default function Login({ api, setAccount, messenger }) {
  const userRememberJSON = localStorage.getItem(btoa("rememberUser"))
    ? JSON.parse(atob(localStorage.getItem(btoa("rememberUser"))))
    : null;
  const [userRemember] = useState(userRememberJSON);

  const [email, setEmail] = useState(
    userRemember ? userRemember.username : null,
  );
  const [password, setPassword] = useState(
    userRemember ? userRemember.password : null,
  );
  const [passwordValid, setPasswordValid] = useState(false);
  const [rememberMe, setRememberMe] = useState(!!userRemember);
  const [formValid, setFormValid] = useState(false);

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const emailValid = email !== "" ? Validations.isEmail(email) : "";

  useEffect(() => {
    setFormValid(email && passwordValid);
  }, [setFormValid, email, passwordValid]);

  const handleLogin = () => {
    setLoading(true);

    api("api/auth/token/", {
      method: "POST",
      ignoreError: true,
      ignoreForbidden: true,
      body: {
        username: email,
        password,
        client_id: process.env.REACT_APP_CLIENT_ID,
        client_secret: process.env.REACT_APP_CLIENT_SECRET,
        grant_type: "password",
      },
    })
      .then(({ ok, body }) => {
        if (ok) {
          if (rememberMe) {
            localStorage.setItem(
              btoa("rememberUser"),
              btoa(JSON.stringify({ username: email, password })),
            );
          } else {
            localStorage.removeItem(btoa("rememberUser"));
          }

          api(`api/providers/${process.env.REACT_APP_SLUG}/users/me/`).then(
            ({ body }) => {
              setAccount(body?.data);
              navigate("/");
            },
          );
        } else {
          let message = "Your email or password is incorrect";
          if (body && body.status_code === "403") {
            message = "To proceed with the login you must activate your account, click on the activation link sent to your email";
          }

          messenger({
            severity: "error",
            detail: message,
            life: 3000,
          });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getPassword = (e) => {
    setPassword(e);
  };

  return (
    <div className={`login-page wrapper-login ${loading ? "loading" : ""}`}>
      {!loading ? (
        <div className="bw-event-container">
          <h2>Log in</h2>
          <Form>
            <Field
              type="text"
              label="Email"
              placeholder="Email"
              value={email}
              setValue={setEmail}
              invalid={email === "" || emailValid === false}
              invalidMessage={
                (email === "" ? "Email is required." : "") ||
                (!emailValid ? "Email is invalid." : "")
              }
              className="bw-event-input"
            />
            <InputPassword
              label="Password"
              placeholder="Enter password"
              initialValue={password}
              emmitValue={getPassword}
              emmitValid={setPasswordValid}
            >
              <p className="bw-event-callout">
                6 to 20 symbols (A-Z, a-z, 0-9)
              </p>
            </InputPassword>
            <div className="flex justify-content-between mt-4">
              <Field
                className="bw-event-checkbox mb-0"
                type="checkbox"
                label="Remember Me"
                value={rememberMe}
                setValue={setRememberMe}
              />
              <Link to="/forgot-password" className="bw-event-link">
                Forgot password
              </Link>
            </div>
            <Button
              className="mx-auto bw-event-btn"
              label="Log in"
              onClick={handleLogin}
              disabled={!formValid}
            />
          </Form>

          <SocialLogin
            api={api}
            navigate={navigate}
            setLoading={setLoading}
            setAccount={setAccount}
          />
        </div>
      ) : (
        <Loading />
      )}
    </div>
  );
}
